<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb :page-title="title" :directory="$t('master')" :icon="'grid'" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<!-- <button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button> -->
					<button type="button" class="btn btn-primary btn-with-shadow" @click="reloadTable">
						<i class="fa fa-sync"></i>
						Refresh Table
					</button>
					<button v-if="useApprovalButton && $can('view_tab_approval_voucher')" type="button"
						:class="`btn ${approveButtonColor} btn-with-shadow`" :disabled="batchButtonDisabled"
						@click="approveVoucherRequest">
						{{ $t("approve_voucher") }}
					</button>
					<button v-if="useApprovalButton && $can('view_tab_approval_voucher')" type="button"
						:class="`btn ${rejectButtonColor} btn-with-shadow`" :disabled="batchButtonDisabled"
						@click="rejectVoucherRequest">
						{{ $t("reject_voucher") }}
					</button>
					<button v-if="useVoucherNeedSendGift && $can('view_tab_approval_voucher')" type="button"
						:class="`btn ${sendGiftButtonColor} btn-with-shadow`" :disabled="batchButtonDisabled"
						@click="sendGiftVoucherRequest">
						{{ $t("send_gift_voucher") }}
					</button>
					<button v-if="useAddButton && $can('view_tab_request_voucher')" type="button"
						class="btn btn-primary btn-with-shadow" data-toggle="modal" @click="openAddEditModal">
						{{ $t("create_voucher") }}
					</button>
				</div>
			</div>
		</div>

		<app-table :id="tableId" :options="options" @action="getListAction" />

		<modal-form v-if="isAddEditModalActive" :table-id="tableId" :form-id="formId"
			:set-as-view-only="showModalAsViewOnly" v-model="rowData" :selected-url="selectedUrl"
			@close-modal="closeAddEditModal" />

		<modal-form-view v-if="showModalAsViewOnly" :modal-id="formId.replace('form', 'view')" v-model="rowData"
			:selected-url="selectedUrl" @close-modal="closeModalView" />

		<modal-form-edit-voucher v-if="isClaimModalActive" :table-id="tableId"
			:form-id="formId.replace('request', 'claim')"
			:modal-title="useVoucherNeedSendGift ? $t('form_voucher_title_gift') : $t('form_voucher_title_claim')"
			:selected-url="selectedUrl" :data-params="['lead_to']" v-model="rowData" @close-modal="closeClaimModal" />

		<app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
			@confirmed="onDelete" @cancelled="onCancelDelete" />
	</div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema";
import { urlGenerator } from "../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	name: "VoucherRequest",
	mixins: [Schema],
	inject: ["eventHub"],
	props: {
		title: {
			type: String,
			required: true,
		},
		useAddButton: {
			type: Boolean,
			// required: true,
			default: false,
		},
		useApprovalButton: {
			type: Boolean,
			default: false,
		},
		useVoucherNeedClaim: {
			type: Boolean,
			default: false,
		},
		useVoucherNeedSendGift: {
			type: Boolean,
			default: false,
		},
		queryString: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			listApproveVoucherRequest: new Set([]),
			listApproveVoucherRequestIds: [],
			listRejectVoucherRequest: new Set([]),
			listRejectVoucherRequestIds: [],
			listClaimVoucherRequest: new Set([]),
			listClaimVoucherRequestIds: [],
			listGiftVoucherRequest: new Set([]),
			listGiftVoucherRequestIds: [],
			batchButtonDisabled: true,
			showModalAsViewOnly: false,
			approveButtonColor: "btn-secondary",
			rejectButtonColor: "btn-secondary",
			sendGiftButtonColor: "btn-secondary",
		};
	},
	created() {
		// this.options.columns = [...this.tableColumns, this.actionObj];
		this.filterTableActions();
		this.filterTableColumns();
		// this.searchAndSelectFilterOptions();
	},
	mounted() {
		this.resetSelection();
		this.eventHub.$on("tableSelectionClearMarked", () => {
			this.resetSelection();
		});
		this.eventHub.$on("selectApproveVoucherRequest", (listSelectedVoucher) => {
			this.listApproveVoucherRequest = new Set(listSelectedVoucher);
			this.listRejectVoucherRequest = new Set(listSelectedVoucher);
			this.listGiftVoucherRequest = new Set(listSelectedVoucher);
			this.performSelectionEffect();
		});
	},
	watch: {
		queryString(newVal) {
			if (newVal) this.options.url = [this.ENDPOINT, newVal].join('?');
			else this.options.url = this.ENDPOINT;
			// console.log(this.options.url);
			this.reloadTable();
		},
		useApprovalButton(newVal) {
			this.filterTableActions();
			this.filterTableColumns();
		},
		useAddButton(newVal) {
			this.filterTableActions();
			this.filterTableColumns();
		},
		useVoucherNeedClaim(newVal) {
			this.filterTableActions();
			this.filterTableColumns();
		},
		useVoucherNeedSendGift(newVal) {
			this.filterTableActions();
			this.filterTableColumns();
		},
	},
	methods: {
		/**
		 * for open modal view
		 */
		openModalView() {
			this.showModalAsViewOnly = true;
		},

		/**
		 * for close modal view
		 */
		closeModalView() {
			let m_id = `#voucher-request-view`;
			$(m_id).modal("hide");
			this.showModalAsViewOnly = false;
		},

		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			let m_id = `#voucher-request-form`;
			$(m_id).modal("hide");
			this.isAddEditModalActive = false;
			// this.searchAndSelectFilterOptions();
			this.reSetData();
		},

		/**
		 * for open claim modal
		 */
		openClaimModal() {
			this.isClaimModalActive = true;
		},

		/**
		 * for close claim modal
		 */
		closeClaimModal() {
			let m_id = `#voucher-claim-form`;
			$(m_id).modal("hide");
			this.isClaimModalActive = false;
			this.reSetData();
			this.reloadTable();
		},

		sendGiftVoucherRequest() {
			this.listGiftVoucherRequestIds = [];
			this.listGiftVoucherRequest.forEach((element) => {
				this.listGiftVoucherRequestIds.push(element.id);
			});
			this.selectedUrl = `api/voucher/sendGifts/${this.listGiftVoucherRequestIds.join(',')}`;
			this.openClaimModal();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;
			console.log('getListAction.rowData:', rowData);

			if (actionObj.title == this.$t("delete")) {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("view")) {
				this.openModalView();
			} else if (actionObj.title == this.$t("approve_voucher")) {
				this.listApproveVoucherRequest = new Set([rowData]);
				this.approveVoucherRequest();
			} else if (actionObj.title == this.$t("reject_voucher")) {
				this.listRejectVoucherRequest = new Set([rowData]);
				this.rejectVoucherRequest();
			} else if (actionObj.title == this.$t("table_voucher_claim_status")) {
				this.selectedUrl = `api/voucher/claim/${rowData.id}`;
				this.openClaimModal();
			} else if (actionObj.title == this.$t("table_voucher_gift_status")) {
				this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
				this.listGiftVoucherRequestIds = [rowData.id];
				this.selectedUrl = `api/voucher/sendGifts/${this.listGiftVoucherRequestIds.join(',')}`;
				this.openClaimModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		performSelectionEffect() {
			// Disable the button if the list is empty
			this.batchButtonDisabled = this.listApproveVoucherRequest.size < 1
				|| typeof this.listApproveVoucherRequest === 'undefined'
				|| this.listApproveVoucherRequest == null;
			if (this.batchButtonDisabled) {
				this.approveButtonColor = "btn-secondary";
				this.rejectButtonColor = "btn-secondary";
				this.sendGiftButtonColor = "btn-secondary";
			} else {
				this.approveButtonColor = "btn-success";
				this.rejectButtonColor = "btn-warning";
				this.sendGiftButtonColor = "btn-info";
			}
		},
		resetSelection() {
			this.listRejectVoucherRequest = new Set([]);
			this.listApproveVoucherRequest = new Set([]);
			this.listGiftVoucherRequest = new Set([]);
			this.batchButtonDisabled = true;
			this.performSelectionEffect();
		},
		filterTableColumns() {
			if (this.useVoucherNeedClaim) {
				this.options.columns = [
					...this.tableColumns.filter(col => col.key != 'approval_status' && col.key != 'gift_status')
				];
			} else if (this.useVoucherNeedSendGift) {
				this.options.columns = [
					...this.tableColumns.filter(col => col.key != 'approval_status' && col.key != 'claim_status')
				];
			} else {
				this.options.columns = [
					...this.tableColumns.filter(col => col.key != 'claim_status' && col.key != 'gift_status')
				];
				// if (this.useApprovalButton) this.options.columns.push(this.actionObj);
			}
			this.options.columns.push(this.actionObj);
		},
		filterTableActions() {
			// if (this.useVoucherNeedSendGift) this.options.actions = [...this.tableActions.filter(act => act.key == "voucher-claim")];
			// else
			if (this.useApprovalButton) {
				this.options.actions = [...this.tableActions.filter(act => act.key == "voucher-approval")];
			}
			// else if (this.useVoucherNeedSendGift) {
			// 	this.options.actions = [...this.tableActions.filter(act => act.key == "voucher-send-gift")];
			// }
			else {
				this.options.actions = [...this.tableActions.filter(act => act.key != "voucher-approval")];
			}
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
			this.resetSelection();
			// this.eventHub.$emit("reload-" + this.tableId);
		},
		approveVoucherRequest() {
			if (this.listApproveVoucherRequest.size < 1 && this.listRejectVoucherRequest.size < 1) {
				this.resetSelection();
				return;
			}
			this.listRejectVoucherRequest = new Set([]);
			Swal.fire({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, approve it!",
				cancelButtonText: "No, cancel!",
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.listApproveVoucherRequestIds = [];
					this.listApproveVoucherRequest.forEach((element) => {
						this.listApproveVoucherRequestIds.push(element.id);
					});
					this.axiosPatch({
						url: `${this.ENDPOINT}/approval`,
						data: {
							id: this.listApproveVoucherRequestIds,
						},
					}).then((response) => {
						if (response.status === 200) {
							Swal.fire({
								title: "Approved!",
								text: "Your voucher request has been approved.",
								icon: "success",
								timer: 2000,
								showConfirmButton: false,
							}).then(() => {
								this.resetSelection();
								this.reloadTable();
							});
						}
					});
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire({
						title: "Cancelled",
						text: "Your voucher request is safe :)",
						icon: "error",
						timer: 2000,
						showConfirmButton: false,
					});
				}
			}).catch((error) => {
				Swal.fire({
					title: "Error!",
					text: error.response.data.message,
					icon: "error",
					timer: 2000,
					showConfirmButton: false,
				});
			}).finally(() => {
				this.resetSelection();
				this.reloadTable();
			});
		},
		rejectVoucherRequest() {
			if (this.listApproveVoucherRequest.size < 1 && this.listRejectVoucherRequest.size < 1) {
				this.resetSelection();
				return;
			}
			this.listApproveVoucherRequest = new Set([]);
			Swal.fire({
				title: "Are you sure?",
				// text: "You won't be able to revert this!",
				text: "Input the reason",
				icon: "warning",
				input: "textarea",
				// inputLabel: "Reasons for the decline:",
				inputPlaceholder: "Type the reason...",
				inputAttributes: {
					"aria-label": "Type the reason"
				},
				preConfirm: (value) => {
					if (!value) {
						Swal.showValidationMessage('Reason for the decline is required')
					}
				},
				confirmButtonText: "Yes, decline it!",
				cancelButtonText: "No, cancel!",
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.listRejectVoucherRequestIds = [];
					this.listRejectVoucherRequest.forEach((element) => {
						this.listRejectVoucherRequestIds.push(element.id);
					});
					this.axiosPatch({
						url: `${this.ENDPOINT}/approval`,
						data: {
							reject_id: this.listRejectVoucherRequestIds,
							reject_reason: result.value,
						},
					}).then((response) => {
						if (response.status === 200) {
							Swal.fire({
								title: "Rejected!",
								text: "Your voucher request has been rejected.",
								icon: "success",
								timer: 2000,
								showConfirmButton: false,
							}).then(() => {
								this.resetSelection();
								this.reloadTable();
							});
						}
					});
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire({
						title: "Cancelled",
						text: "Your voucher request is safe :)",
						icon: "error",
						timer: 2000,
						showConfirmButton: false,
					});
				}
			}).catch((error) => {
				Swal.fire({
					title: "Error!",
					text: error.response.data.message,
					icon: "error",
					timer: 2000,
					showConfirmButton: false,
				});
			}).finally(() => {
				this.resetSelection();
				this.reloadTable();
			});
		},
	},
};
</script>
